import {post} from '@/utils/request';
import {erpserver} from '@/utils/baseUrl';
import{videoplatserver,videoserver} from '@/utils/baseUrl';
import{sse_url} from '@/utils/baseUrl';


//编辑设备列表
export async function updateDevice(params) {
    return post(videoserver+'/device/updateDevice',params,true);
}

//设备列表
export async function getDeviceList(params) {
    return post(videoserver+'/device/getDeviceList',params,true);
}

//新增素材
export async function batchDelResource(params) {
    return post(videoserver+'/resource/batchDelResource',params,true);
}

//新增素材
export async function addResource(params) {
    return post(videoserver+'/resource/addResource',params,true);
}

//素材列表
export async function getResourceList(params) {
    return post(videoserver+'/resource/getResourceList',params,true);
}

//删除
export async function delArrangement(params) {
    return post(videoserver+'/arrange/delArrangement',params,true);
}

//tree
export async function getDeviceTree(params) {
    return post(videoserver+'/device/getDeviceTree',params,true);
}

//新增/编辑保存
export async function arrangeProgram(params) {
    return post(videoserver+'/arrange/programArrangement',params,true);
}


//放映列表
export async function getArrangementList(params) {
    return post(videoserver+'/arrange/getArrangementList',params,true);
}

//上传图片
export async function upload(params) {
    return post(videoplatserver+'/system/uploadFile',params,false);
}
/**********************************************************************************************/

//关闭SSE
export async function closeSSE(params) {
    return post(sse_url+'/closeSSE', params, true);
}


// 获取公司
export async function getCompanyList(params) {
    return post(erpserver+'/currency/getCompanyList', params, true);
}

//保存列表
//saveCarryOver;
export async function saveCarryOver(params) {
    return post(erpserver+'/sell/saveCarryOver', params, true);
}

//公司列表
//getCbJsList;
export async function getCbJsList(params) {
    return post(erpserver+'/sell/getCbJsList', params, true);
}

//完结
export async function carryOverEnd(params) {
    return post(erpserver+'/sell/carryOverEnd', params, true);
}

//结转
export async function carryOver(params) {
    return post(erpserver+'/sell/carryOver', params, true);
}

//获取进度条列表
export async function getCarryOverList(params) {
    return post(erpserver+'/sell/getCarryOverList', params, true);
}

//获取成本结转时间
export async function getCbJsTime(params) {
    return post(erpserver+'/sell/getCbJsTime', params, true);
}

//获取未结转时间
export async function getJsTime(params) {
    return post(erpserver+'/sell/getJsTime', params, true);
}

//获取下月销售开票列表
export async function getSellInvoiceNextList(params) {
    return post(erpserver+'/sell/getSellInvoiceNextList', params, true);
}

//更新下月销售开票状态
export async function updSellInvoiceNext(params) {
    return post(erpserver+'/sell/updSellInvoiceNext', params, true);
}

//获取销售开票列表
export async function getSellInvoiceList(params) {
    return post(erpserver+'/sell/getSellInvoiceList', params, true);
}

//更新销售开票状态
export async function updSellInvoice(params) {
    return post(erpserver+'/sell/updSellInvoice', params, true);
}

//获取内部交易列表
export async function getInSellList(params) {
    return post(erpserver+'/sell/getInSellList', params, true);
}

//更新内部交易状态
export async function updInSell(params) {
    return post(erpserver+'/sell/updInSell', params, true);
}